module.exports = __webpack_public_path__ + "img/photo.e6048d54.jpg";